import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "p-h01-point-confirm-item__content" }
const _hoisted_3 = { class: "p-h01-point-confirm-item__meta" }
const _hoisted_4 = {
  key: 1,
  class: "p-h01-point-confirm-item__date"
}
const _hoisted_5 = { class: "p-h01-point-confirm-item__detail" }
const _hoisted_6 = { class: "p-h01-point-confirm-item__icon" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "p-h01-point-confirm-item__description" }
const _hoisted_9 = {
  key: 0,
  class: "p-h01-point-confirm-item__group",
  "data-translate-skip": ""
}
const _hoisted_10 = ["data-translate-skip"]
const _hoisted_11 = { class: "p-h01-point-confirm-item__aside" }
const _hoisted_12 = { class: "p-h01-point-confirm-item__value" }
const _hoisted_13 = { class: "p-h01-point-confirm-item__point__sign" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconInvestedRounded = _resolveComponent("IconInvestedRounded")!
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_TextLabel = _resolveComponent("TextLabel")!
  const _component_PointNotation = _resolveComponent("PointNotation")!
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      href: _ctx.url,
      class: "p-h01-point-confirm-item"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.status)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["p-h01-point-confirm-item__status", `p-h01-point-confirm-item__status--${_ctx.usage}`])
              }, _toDisplayString(_ctx.status), 3))
            : _createCommentVNode("", true),
          (_ctx.date)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.date), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.iconType === 1)
              ? (_openBlock(), _createBlock(_component_IconInvestedRounded, {
                  key: 0,
                  type: _ctx.iconPath,
                  "icon-size": 24,
                  "bg-color": _ctx.colorCode,
                  "icon-color": "#ffffff"
                }, null, 8, ["type", "bg-color"]))
              : (_openBlock(), _createBlock(_component_IconUserImage, {
                  key: 1,
                  size: 24,
                  unread: _ctx.unread
                }, {
                  default: _withCtx(() => [
                    (_ctx.iconPath !== false && _ctx.iconPath !== '')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.iconPath,
                          alt: ""
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["unread"]))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.group)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.group), 1))
              : _createCommentVNode("", true),
            (_ctx.name)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "p-h01-point-confirm-item__name",
                  "data-translate-skip": _ctx.status !== '利用' ? '' : null
                }, _toDisplayString(_ctx.name), 9, _hoisted_10))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass(["p-h01-point-confirm-item__labels", { '-empty': !_ctx.hasLabels }])
          }, [
            (_ctx.approvedEnabled && _ctx.approved)
              ? (_openBlock(), _createBlock(_component_TextLabel, {
                  key: 0,
                  color: { border: '#777777', content: '#ffffff' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.approved), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.label)
              ? (_openBlock(), _createBlock(_component_TextLabel, {
                  key: 1,
                  color: { border: _ctx.colorCode, content: '#ffffff' },
                  reverse: _ctx.reverseLabelColor
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.label), 1)
                  ]),
                  _: 1
                }, 8, ["color", "reverse"]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["p-h01-point-confirm-item__point", 
              _ctx.sign
                ? 'p-h01-point-confirm-item__point--plus'
                : 'p-h01-point-confirm-item__point--minus'
            ])
          }, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.sign ? "+" : "−"), 1),
            _createVNode(_component_PointNotation, {
              "icon-size": false,
              point: _ctx.point,
              "point-color": _ctx.pointColor,
              "sign-is-exists": false,
              "font-size": _ctx.pointNotationStyle.fontSize
            }, null, 8, ["point", "point-color", "font-size"])
          ], 2)
        ]),
        _createVNode(_component_IconBase, {
          class: "p-h01-point-confirm-item__arrow",
          width: 24,
          height: 24,
          "view-box": "0 0 24 24"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconArrowRight)
          ]),
          _: 1
        })
      ])
    ], 8, _hoisted_1)
  ]))
}